import React from 'react';
import EmailInput from '../email_input/index.js';
import FormFooter from './FormFooter.js'
import Notification from '../notification/index.js';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'react-flexbox-grid';
import fire from '../../config/fire.js';
import * as firebase from "firebase";
import 'normalize.css';
import '../../style/index.css'

class Emails extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = { 
      email: '', 
      valid: null,
      uniq: null,
      buttonClasses: 'button button__input',
      submited: null
    }

    this.changeEmail = this.changeEmail.bind(this);
    this.setValid = this.setValid.bind(this);
    this.submitEmail = this.submitEmail.bind(this);
    this.saveEmail = this.saveEmail.bind(this);
    this.resetDefault = this.resetDefault.bind(this);
    this.beforeSubmit = this.beforeSubmit.bind(this);
    this.afterSubmit = this.afterSubmit.bind(this);
    this.noticeDiv = this.noticeDiv.bind(this);
  }


  resetDefault() {
    this.setState({ 
      email: '', 
      valid: null,
      uniq: null,
      buttonClasses: 'button button__input',
      submited: null
    });
  }

  saveEmail(email) {
    this.setState({ submited: false });
    const thisBuff = this;
    
    const data = {
      email: email,
      invited: false,
      createdAt: firebase.database.ServerValue.TIMESTAMP
    }

    const ref = fire.database().ref('emails')
    
    ref.orderByChild('email').equalTo(email).once('value').then(function(snapshot) {
      if (snapshot.val() === null) {
        fire.database().ref('emails').push(data);
        thisBuff.setState({ uniq: true, submited: true });
      } else {
        thisBuff.setState({ uniq: false, submited: true });
      }
    });
    return false;
  }

  changeEmail(newEmail) {
    this.setState({ email: newEmail });
  }

  setValid(newValid) {
    if(newValid){
      this.setState({ valid: newValid, buttonClasses: 'button button__input button--success'});
    } else{
      this.setState({ valid: newValid, buttonClasses: 'button button__input'});
    }
  }

  submitEmail(e) {
    if(!this.state.valid) {
      return false;
    }
    const email = this.state.email;
    this.saveEmail(email)
    e.preventDefault();
    return false;
  }

  beforeSubmit(circleClass) {
    return(
      <form className='form shadow' onSubmit= { this.submitEmail }>
        <Row>
          <Col xsOffset={1} xs={10}>
            <div className='modal-header text--center'>Запрошення на <b>Cinematico</b></div>
          </Col>
        </Row>

        <Row>
          <Col xsOffset={1}  xs={10} >
            <p className='text--center text--grey'>Сінематико – це сайт про кіно. <br />Ми запустимось <b>у березні 2020-го</b> року в режимі закритого бета-тестування. Якщо ви хочете бути одними із перших, хто отримає доступ до нього – залиште свою електронну адресу.</p>
          </Col>
        </Row>
        <Row>
          <Col xs={1} className='container__relative'>
            <FontAwesome name='check-circle-o' size='2x' className={ circleClass } />
          </Col>
          <Col xs={10} className='container__relative'>
            <EmailInput onChange={ this.changeEmail } setValid={ this.setValid } />
            <input type='submit' value='Відправити' className={ this.state.buttonClasses } type='submit' disabled={ !this.state.valid }></input>    
          </Col>
        </Row>

        <FormFooter />
      </form>
    );
  }

  afterSubmit(circleClass) {
    return(
      <form className='form shadow'>
        <Row>
          <Col xsOffset={1} xs={10}>
            <div className='modal-header text--center'>Запрошення на <b>Cinematico</b></div>
          </Col>
        </Row>

        <Row >
         <Col xsOffset={1}  xs={10} >
            <p className='text--center text--grey'>Обробляємо...</p>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className='container__relative'>
            <FontAwesome spin name='check-circle-o' size='2x' className={ circleClass } />
          </Col>
          <Col xs={10} className='container__relative'>
            <EmailInput onChange={ this.changeEmail } setValid={ this.setValid } />
            <input type='submit' value='Відправити' className="button button__input" type='submit' disabled={ true }> 
            </input>
          </Col>
        </Row>
        
        <FormFooter />        
      </form>
    );
  }

  noticeDiv() {
    return(
      <div className='notification shadow'>
        < Notification uniq={ this.state.uniq } email={ this.state.email } resetDefault={ this.resetDefault }/>
      </div>
    );
  }

  render() {
    let submited = this.state.submited;
    let valid = this.state.valid;
    let circleClass = '';

    if(valid === null) {
      circleClass = 'hide i__input';
    } else if (valid === false) {
      circleClass = 'badge badge-error i__input';
    } else if(valid === true) {
      circleClass = 'badge badge--success i__input';
    }

    if (submited === null) {
      return(this.beforeSubmit(circleClass));
    } else if(submited === false) {
      return(this.afterSubmit(circleClass));
    } else if(submited === true) {
      return(this.noticeDiv());
    }
  }
}

export default Emails;



// WEBPACK FOOTER //
// ./src/components/form/index.js